/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable functional/prefer-readonly-type */
/* eslint-disable functional/immutable-data */
/* eslint-disable max-lines-per-function */
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useLang } from '~/hooks/useLang'
import Layout from '~/components/Layout'
import InternalHeader from '~/components/Layout/components/InternalHeader'
import InternalContent from '~/components/Layout/components/InternalContent'
import FilterAutocompleteCity from '~/components/FilterSelectAutocompleteCity'
import FilterAutocompleteDistrict from '~/components/FilterSelectAutocompleteDistrict'
import FilterAutocompleteTypeInterestPoint from '~/components/FilterAutocompleteTypeInterestPoint'
import FilterAutocompleteSubtypesByTypeInterestPoint from '~/components/FilterAutocompleteSubtypesByTypeInterestPoint'
import FilterTextField from '~/components/FilterTextField'
import { useHookstate } from '@hookstate/core'
import { Button, InputLabel, FormHelperText, Box, Grid } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import FilterAutocompleteAgency from '~/components/FilterAutocompleteAgency'
import FilterAutocompleteFetch from '~/components/FilterAutocompleteFetch'
import { ImportFileFieldWithoutSaveButton } from '~/components/ImportFileFieldWithoutSaveButton'
import FilterGeographicalSinglePoint from '~/features/Map/components/FilterGeographicalSinglePoint'
import type ICity from '~/features/City/interfaces/ICity'
import { useEffect } from 'react'
import { authFetch } from '~/services/fetch'
import notify from '~/utils/notify'

export default function Create() {
  const history = useHistory()
  const { translate } = useLang()
  const loading = useHookstate<boolean>(false)
  const name = useHookstate<string>('')
  const location = useHookstate<string | null>(null)
  const latitude = useHookstate<string>('')
  const longitude = useHookstate<string>('')
  const cityId = useHookstate<number | null>(null)
  const cityState = useHookstate<ICity | null>(null)
  const districtId = useHookstate<number | null>(null)
  const districtState = useHookstate<{ id: string | null; name: string }>({
    id: null,
    name: '',
  })
  const interestPointTypeId = useHookstate<number | null>(null)
  const interestPointSubtypeId = useHookstate<number | null>(null)
  const informationUserId = useHookstate<number | ''>('')
  const agencyId = useHookstate<number | null>(null)
  const notes = useHookstate<string>('')

  const medias = useHookstate<
    ReadonlyArray<{ readonly file: string; readonly file_type: string }>
  >([])
  const errors = useHookstate<{ readonly [key: string]: string }>({})
  const id = useHookstate<number | null>(null)
  const [fileFieldKey, setFileFieldKey] = useState(0)

  // Sincronizar cityState com cityId
  useEffect(() => {
    const city = cityState.get()
    if (city && city.id !== cityId.get()) {
      cityId.set(city.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityState])

  // Sincronizar districtState com districtId
  useEffect(() => {
    const district = districtState.get()
    if (district && district.id && parseInt(district.id) !== districtId.get()) {
      districtId.set(parseInt(district.id))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [districtState])

  const validate = () => {
    const newErrors: { [key: string]: string } = {}
    if (!name.get()) newErrors.name = translate('Location name is required')
    if (!location.get()) newErrors.location = translate('Location is required')
    if (!latitude.get()) newErrors.latitude = translate('Latitude is required')
    if (!longitude.get())
      newErrors.longitude = translate('Longitude is required')
    if (!cityId.get()) newErrors.city_id = translate('City is required')
    if (!interestPointTypeId.get())
      newErrors.interest_point_type_id = translate(
        'Interest point type is required'
      )
    if (!informationUserId.get())
      newErrors.information_user_id = translate('Reporting user is required')
    if (!agencyId.get()) newErrors.agency_id = translate('Agency is required')
    errors.set(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const handleClear = () => {
    name.set('')
    location.set('')
    latitude.set('')
    longitude.set('')
    cityId.set(null)
    cityState.set(null)
    districtId.set(null)
    districtState.set({ id: null, name: '' })
    interestPointTypeId.set(null)
    interestPointSubtypeId.set(null)
    informationUserId.set('')
    agencyId.set(null)
    notes.set('')
    location.set(null)
    medias.set([])
    errors.set({})
    setFileFieldKey((prev) => prev + 1) // Adicione esta linha
  }

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault()
    if (!validate()) return
    loading.set(true)
    const formData = {
      name: name.get(),
      location: location.get(),
      latitude: Number(latitude.get()),
      longitude: Number(longitude.get()),
      city_id: cityId.get(),
      district_id: districtId.get(),
      interest_point_type_id: interestPointTypeId.get(),
      interest_point_subtype_id: interestPointSubtypeId.get(),
      information_user_id: informationUserId.get(),
      notes: notes.get(),
      agency_id: agencyId.get(),
      medias: medias.get(),
    }
    try {
      await authFetch({
        url: '/interest-point/store',
        method: 'POST',
        data: formData,
      })
      await notify({
        message: translate('Interest point created successfully!'),
        type: 'success',
      })
      handleClear()
    } catch (error: unknown) {
      console.error('Erro ao criar ponto de interesse:', error)
      notify({
        message: translate('Error creating interest point'),
        type: 'error',
      })
    } finally {
      loading.set(false)
    }
  }

  const handleFileChange = (
    files: ReadonlyArray<{
      image: string | null
      type: string
    }>
  ) => {
    const formattedFiles = files
      .filter((file) => file.image)
      .map((file) => ({
        file: file.image as string,
        file_type: file.type,
      }))
    // Só atualiza se mudou de fato
    if (JSON.stringify(medias.get()) !== JSON.stringify(formattedFiles)) {
      medias.set(formattedFiles)
    }
  }

  return (
    <Layout marginLayout={true}>
      <InternalHeader title={translate('create interest point')} />
      <InternalContent expandButton={false}>
        <form onSubmit={handleSubmit}>
          <Box mb={2}>
            <Grid container spacing={2}>
              <Grid item xs={2} md={3}>
                <FilterTextField
                  label={translate('Location Name')}
                  currentText={name.get()}
                  onTextFieldChange={(val) => name.set(val ?? '')}
                  error={!!errors.get().name}
                  isRequired
                />
                {errors.get().name && (
                  <FormHelperText error>{errors.get().name}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterGeographicalSinglePoint
                  localTextValue={location}
                  lat={latitude}
                  long={longitude}
                  city={cityState}
                  district={districtState}
                  error={!!errors.get().location}
                  isRequired
                />
                {errors.get().location && (
                  <FormHelperText error>{errors.get().location}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteCity
                  cityId={cityId.get()}
                  onCityChange={(id) => cityId.set(id ?? null)}
                  isInvalidRequest={!!errors.get().city_id}
                  disabled={false}
                  isRequired
                />
                {errors.get().city_id && (
                  <FormHelperText error>{errors.get().city_id}</FormHelperText>
                )}
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteDistrict
                  cityId={cityId.get()}
                  districtId={districtId}
                  onDistrictChange={(value) => districtId.set(value)}
                  disabled={false}
                />
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteTypeInterestPoint
                  typeInterestPointId={interestPointTypeId.get()}
                  disabled={false}
                  onTypeInterestPointChange={(typeInterestPoint) =>
                    interestPointTypeId.set(typeInterestPoint?.id ?? null)
                  }
                  error={!!errors.get().interest_point_type_id}
                  isRequired
                />
                {errors.get().interest_point_type_id && (
                  <FormHelperText error>
                    {errors.get().interest_point_type_id}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteSubtypesByTypeInterestPoint
                  typeInterestPointId={interestPointTypeId.get()}
                  subtypesInterestPoint={interestPointSubtypeId.get() ?? null}
                  disabled={!interestPointTypeId.get()}
                  onSubtypesInterestPointChange={(subtypeInterestPoint) =>
                    interestPointSubtypeId.set(subtypeInterestPoint?.id ?? null)
                  }
                />
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteFetch
                  label={translate('Reporting User*')}
                  urlFetch={'/user/get'}
                  size="small"
                  disabled={false}
                  onFetchChange={(user: number | null) =>
                    informationUserId.set(user ?? '')
                  }
                  resetValues={undefined}
                  focusChange={undefined}
                  error={!!errors.get().information_user_id}
                  valueId={
                    informationUserId.get()
                      ? Number(informationUserId.get())
                      : undefined
                  }
                />
                <Box mt={2} pt={0.1}>
                  {errors.get().information_user_id && (
                    <FormHelperText error>
                      {errors.get().information_user_id}
                    </FormHelperText>
                  )}
                </Box>
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterAutocompleteAgency
                  agencyId={agencyId.get()}
                  onAgencyChange={(agency) => agencyId.set(agency)}
                  errorForm={!!errors.get().agency_id}
                  isRequired
                />
                {errors.get().agency_id && (
                  <FormHelperText error>
                    {errors.get().agency_id}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={2} md={3}>
                <FilterTextField
                  label={translate('Notes')}
                  currentText={notes.get()}
                  onTextFieldChange={(val) => notes.set(val ?? '')}
                />
              </Grid>
            </Grid>
            <Grid container mt={2}>
              <Grid item xs={2.9}>
                <InputLabel>{translate('Location Photo')}</InputLabel>
                <ImportFileFieldWithoutSaveButton
                  key={fileFieldKey} // Adicione esta linha
                  dispatchId={id.get()}
                  onFileSelected={handleFileChange}
                />
              </Grid>
            </Grid>
          </Box>
          <Grid
            container
            mt={2}
            display="flex"
            justifyContent="flex-end"
            gap={2}
            width={'100%'}
          >
            <Button
              type="button"
              variant="outlined"
              color="primary"
              onClick={handleClear}
              disabled={loading.get()}
            >
              {translate('Clear')}
            </Button>
            <LoadingButton
              type="submit"
              variant="contained"
              color="primary"
              loading={loading.get()}
              loadingIndicator={translate('Saving...')}
            >
              {translate('Save')}
            </LoadingButton>
          </Grid>
        </form>
      </InternalContent>
    </Layout>
  )
}
